<rt-interview-base-box
  [question]="questionForm.value"
  [rtProtectedControl]="questionForm.get('attachmentIds')"
  [invalid]="
    questionForm.invalid && (questionForm.dirty || questionForm.touched) && formSubmissionAttempt
  "
>
  @if (files && files.length) {
    <div layout margin-bottom>
      <rt-attachments-list
        [attachments]="files"
        [small]="true"
        [deletable]="true"
        [canManageCandidates]="canManageCandidates"
        (deleteClick)="dispatchDeleteFile($event)"
      >
      </rt-attachments-list>
    </div>
  }
  <rt-group variant="inline">
    <rt-button variant="tertiary" #fileSelectButton [loading]="!!uploading" class="flow-browse">
      {{ 'app.interview.file.label' | translate }}
    </rt-button>
  </rt-group>
</rt-interview-base-box>
